// extracted by mini-css-extract-plugin
export default {"wrapper":"formBreadcrumbs_wrapper__MMyEF","breadcrumSeparator":"formBreadcrumbs_breadcrumSeparator__Hw2a-"};